import { Mail, ShieldCheck, FileText, Trash2 } from "lucide-react";

const PRIVACY_URL = "https://sites.google.com/view/nfpprivacypolicy/home";
const TERMS_URL = "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/";
const SUPPORT_URL = "https://sites.google.com/view/nfp-support/home";
const SUPPORT_EMAIL = "Tray@nofatiguetraining.net";

export default function SupportSection() {
  return (
    <section
      id="support"
      className="relative nfp-section bg-[#0a0a0a]"
      data-testid="section-support"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="rounded-3xl border border-white/10 bg-[#0c0c0c] p-8 md:p-12 grid md:grid-cols-2 gap-10">
          <div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-[#1FA2FF] mb-3">
              Need Help?
            </p>
            <h2 className="nfp-heading text-white text-4xl md:text-5xl leading-[1] tracking-tight">
              We're here <br /> for you.
            </h2>
            <p className="mt-5 text-white/65 leading-relaxed">
              For app support, account questions, subscription issues, bug reports
              or general inquiries — contact NFP support directly.
            </p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid="support-email-cta"
              className="mt-6 inline-flex items-center gap-2 nfp-btn nfp-btn-primary"
            >
              <Mail className="w-4 h-4" />
              {SUPPORT_EMAIL}
            </a>
          </div>

          <ul className="space-y-3">
            <SupportRow
              icon={<ShieldCheck className="w-5 h-5" />}
              title="Privacy Policy"
              text="Read how NFP handles your data."
              href={PRIVACY_URL}
              testid="support-row-privacy"
            />
            <SupportRow
              icon={<FileText className="w-5 h-5" />}
              title="Terms of Use (EULA)"
              text="Apple Standard EULA — required for App Store apps."
              href={TERMS_URL}
              testid="support-row-terms"
            />
            <SupportRow
              icon={<Mail className="w-5 h-5" />}
              title="Support Center"
              text="Visit the NFP support site for FAQs and articles."
              href={SUPPORT_URL}
              testid="support-row-center"
            />
            <SupportRow
              icon={<Trash2 className="w-5 h-5" />}
              title="Delete Your Account"
              text="In-app path: Profile → Settings → Account → Delete Account."
              testid="support-row-delete"
            />
          </ul>
        </div>
      </div>
    </section>
  );
}

const SupportRow = ({ icon, title, text, href, testid }) => {
  const inner = (
    <div className="flex items-start gap-4 p-5 rounded-2xl border border-white/10 hover:border-[#1FA2FF]/40 hover:bg-white/[0.02] transition-all">
      <div className="w-10 h-10 rounded-lg bg-[#1FA2FF]/10 border border-[#1FA2FF]/30 text-[#00E5FF] flex items-center justify-center shrink-0">
        {icon}
      </div>
      <div>
        <p className="text-white font-semibold">{title}</p>
        <p className="text-sm text-white/55 mt-0.5 leading-relaxed">{text}</p>
      </div>
    </div>
  );
  if (!href) return <li data-testid={testid}>{inner}</li>;
  return (
    <li data-testid={testid}>
      <a href={href} target="_blank" rel="noopener noreferrer">
        {inner}
      </a>
    </li>
  );
};
